import { LegalEntityEnum } from '@onrunning/backstage-models';

export const AccountsReceivablesEmails: Omit<
  Record<LegalEntityEnum, string>,
  LegalEntityEnum.ON_CN | LegalEntityEnum.ON_HK | LegalEntityEnum.ON_MX
> = {
  [LegalEntityEnum.ON_AG]: 'ar@on.com',
  [LegalEntityEnum.ON_US]: 'usfinance@on.com',
  [LegalEntityEnum.ON_AU]: 'ar_oceania@on-running.com',
  [LegalEntityEnum.ON_JP]: 'onjp_accounts_receivable@on-running.com',
  [LegalEntityEnum.ON_CA]: 'usfinance@on.com',
  [LegalEntityEnum.ON_BR]: 'financeiro@on-running.com',
  [LegalEntityEnum.ON_UK]: 'ar.uk@on.com',
  [LegalEntityEnum.ON_KR]: 'ar_korea@org.on-running.com',
  [LegalEntityEnum.ON_CH]: 'ar@on.com',
};
